import React from 'react';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';

// Selector
import { useActiveTableCallback, useActiveTableSelector } from '../../../../../element/table/store/hotTableStoreHooks';
import { selectActiveTableCellSelection } from '../../../../../element/table/store/selectors/activeHotTableSelectors';
import { isSelectingMultipleSelections } from '../../../../../element/table/utils/selectionUtils/tableSelectionPredicateUtils';
import createSwitchableTableComponent from './createSwitchableTableComponent';
import LegacyAddRowTool from './legacy/LegacyAddRowTool';

// Components
import ToolbarTool from '../../ToolbarTool';
import Icon from '../../../../../components/icons/Icon';

// Actions
import { addHotTableRowsBelow } from '../../../../../element/table/utils/hotInstanceUtils/grid/hotTableGridOperationsUtils';

type AddRowToolProps = Record<string, unknown> & {
    element?: ImMNElement;
};

const AddRowTool: React.FC = (props) => {
    const currentCellSelections = useActiveTableSelector(selectActiveTableCellSelection);

    const onClick = useActiveTableCallback((activeTable) => addHotTableRowsBelow(activeTable.instance, undefined), []);

    return (
        <div className="AddRowTool">
            <ToolbarTool
                {...props}
                onClick={onClick}
                isActive={false}
                disabled={isSelectingMultipleSelections(currentCellSelections)}
                tooltipEnabled={true}
                shortcut={['alt', '↓']}
            >
                <Icon name="toolbar-add-row" />
            </ToolbarTool>
        </div>
    );
};

export default createSwitchableTableComponent<AddRowToolProps>(LegacyAddRowTool, AddRowTool);
